import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=6db1e9d9&scoped=true&"
import script from "./ResetView.vue?vue&type=script&lang=js&"
export * from "./ResetView.vue?vue&type=script&lang=js&"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=6db1e9d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db1e9d9",
  null
  
)

export default component.exports